
import {
  Component, Watch, Mixins,
} from 'vue-property-decorator';
import FilterItem from '@/features/settings/components/preferences/FilterItem.vue';
import { UserPreferences } from '@/features/settings/types';
import { CarrierFilterType } from '@/features/common/raw';
import { patchPreferences } from '@/features/settings/services/preferences.services';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { fetchSupportedServiceLevels } from '@/features/shipment/services/shipment.services';
import { PreferencesMixin } from './mixins';

@Component({
  components: {
    FilterItem,
  },
})
export default class CarrierFilters extends Mixins(PreferencesMixin, ResponsivenessMixin) {
  private serviceLevels: CarrierFilterType[] = [];

  private carriersToFilter: Array<CarrierFilterType> = [];

  private showFilterAlert = {
    success: false,
    show: false,
  };

  get isUserPreferences(): number {
    return this.$store.getters.getIsUserPreferences;
  }

  get userPreferences(): UserPreferences {
    return this.$store.getters.getUserPreferences;
  }

  get selectedCarriersCount(): number {
    return this.carriersToFilter
      .filter((item) => item.name !== 'TotalShip' && item.show === true).length;
  }

  get isSelectAllOptions(): boolean {
    const filterable = this.carriersToFilter.filter((item) => item.name !== 'TotalShip');
    return filterable.length > 0 && this.selectedCarriersCount === filterable.length;
  }

  set isSelectAllOptions(isShow: boolean) {
    for (let i = 0; i < this.carriersToFilter.length; i += 1) {
      this.carriersToFilter[i].show = isShow;
      for (let j = 0; j < this.carriersToFilter[i].levels.length; j += 1) {
        this.carriersToFilter[i].levels[j].show = isShow;
      }
    }
    this.syncSettings();
  }

  @Watch('isUserPreferences', { immediate: true })
  private async populateCarrierFiltersFromServices(newValue: number) {
    if (!newValue) return;

    await this.populateSupportedServiceLevels();
    this.populatePreferences();
  }

  private async populateSupportedServiceLevels() {
    const levels = await fetchSupportedServiceLevels();

    const servicesWithLevels: CarrierFilterType[] = [];
    levels.forEach((level) => {
      const carrierCode = servicesWithLevels.find((s) => s.name === level.carrierCode);

      if (!carrierCode) {
        servicesWithLevels.push({
          name: level.carrierCode,
          show: false,
          levels: [],
        });
      }

      for (const service of servicesWithLevels) {
        if (service.name === level.carrierCode) {
          service.levels.push({
            name: level.displayName,
            value: level.selectedService,
            show: false,
          });
          break;
        }
      }
    });

    this.serviceLevels = servicesWithLevels;
  }

  private populatePreferences() {
    const { carrierFilters } = this.userPreferences;
    this.prepareFilter(carrierFilters || []);
  }

  private prepareFilter(carrierFiltersPref: string[]) {
    const clonedCarrierFilterItems = [...this.serviceLevels];

    for (let i = 0; i < clonedCarrierFilterItems.length; i += 1) {
      let isShow = false;
      for (let j = 0; j < clonedCarrierFilterItems[i].levels.length; j += 1) {
        if (carrierFiltersPref.includes(
          clonedCarrierFilterItems[i].levels[j].value,
        )) {
          clonedCarrierFilterItems[i].levels[j].show = true;
          isShow = true;
        }
      }
      clonedCarrierFilterItems[i].show = isShow;
    }

    this.carriersToFilter = [...clonedCarrierFilterItems];
  }

  private toggleService({ value, name }): void {
    for (let i = 0; i < this.carriersToFilter.length; i += 1) {
      if (this.carriersToFilter[i].name === name) {
        this.carriersToFilter[i].show = value;
        for (let j = 0; j < this.carriersToFilter[i].levels.length; j += 1) {
          this.carriersToFilter[i].levels[j].show = value;
        }
        this.syncSettings();
        return;
      }
    }
  }

  private toggleLevel({ value, serviceName, levelValue }): void {
    for (let i = 0; i < this.carriersToFilter.length; i += 1) {
      if (this.carriersToFilter[i].name === serviceName) {
        for (let j = 0; j < this.carriersToFilter[i].levels.length; j += 1) {
          if (this.carriersToFilter[i].levels[j].value === levelValue) {
            this.carriersToFilter[i].levels[j].show = value;
            this.syncSettings();

            const isExists = this.carriersToFilter[i].levels.find((level) => level.show);
            this.carriersToFilter[i].show = !!isExists;

            return;
          }
        }
      }
    }
  }

  private async syncSettings() {
    const carriersLevels: string[] = [];

    for (let i = 0; i < this.carriersToFilter.length; i += 1) {
      for (let j = 0; j < this.carriersToFilter[i].levels.length; j += 1) {
        if (this.carriersToFilter[i].levels[j].show) {
          carriersLevels.push(this.carriersToFilter[i].levels[j].value);
        }
      }
    }

    this.patchPreferenceInStore('carrierFilters', carriersLevels);

    const response = await patchPreferences(this.userPreferences.id, [
      {
        path: 'carrierFilters',
        op: 'replace',
        value: carriersLevels,
      },
    ]);

    this.showFilterAlert = {
      show: true,
      success: !!response,
    };
  }
}
